import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultFastTextAreaField } from 'src/components/mui-overrides/Textarea';

interface Props {
  disabled?: boolean;
}

export const DistrictDetailsTextField: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();

  return (
    <DefaultFastTextAreaField
      disabled={disabled}
      label={t('dashboard.assets.addedit.main.districtdetails.fields.districtDetails.label')}
      fieldName="descriptions.districtDetails"
    />
  );
};
